// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"e8da703b","60":"e8da703b","73":"e8da703b","182":"e8da703b","185":"c0c0de9b","362":"73a28ca8","615":"e8da703b","644":"e8da703b","775":"e8da703b","798":"e8da703b","825":"9bd98696"}[chunkId] + ".chunk.css";
};